<template>
<div>
  <b-container>
    <b-row>
      <b-col md="6">
        <h1>Education Type</h1>
        
        <b-alert variant="danger" :show="error != ''">{{ error }}</b-alert>
        
        <ValidationObserver v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(save)">
            <b-form-group
              label="Name"
            >
              <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                <b-form-input v-model="form.name" :state="errors[0] ? false : null"></b-form-input>
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>
          
            <b-form-row>
              <b-col cols="3">
                <b-form-group
                  label="Expires In"
                >
                  <ValidationProvider name="Expires In" rules="required|numeric" v-slot="{ errors }">
                    <b-form-input v-model.number="form.expiresIn" :state="errors[0] ? false : null"></b-form-input>
                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Unit"
                >
                  <b-form-select :options="expiryUnits" v-model="form.expiryUnit"></b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-button variant="outline-secondary" class="mr-2" to="/educationtype" :disabled="saving">Back</b-button>
            <b-button type="submit" variant="primary" :disabled="saving">
              <span v-if="!saving">Save</span>
              <b-spinner small v-else></b-spinner>
            </b-button>
          </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>      

  </b-container>
</div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import axios from 'axios';

export default {
    components: { ValidationProvider, ValidationObserver },
    data() {
      return {
        expiryUnits: [
          { value: 0, text: 'Days'},
          { value: 1, text: 'Months'},
          { value: 2, text: 'Years'}
        ],
        form: {
          name: '',
          expiresIn: 0,
          expiryUnit: 2
        },
        error: '',
        saving: false
      }
    },
    methods: {
      save() {
        this.error = '';
        this.saving = true;
        
        axios.put(`/api/educationtypes/${this.$route.params.id}` , this.form)
        .then(() => {
          this.$router.push('/educationtype');
        })
        .catch(() => { 
          this.error = 'Failed to save';
          this.saving = false;
        });
      }
    },
    created() {
      axios.get(`/api/educationtypes/${this.$route.params.id}`)
      .then(res => {
        this.form = res.data;
      })
    }
}
</script>